<template>
    <div class="not-found-content">
        <div class="banner-text text-center">
            <h1 class="font-weight-bold">
                404
            </h1>

            <h4 class="mt-3 mb-1">
                The page was not found.
            </h4>
        </div>

        <div class="banner-img" />
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
})
export default class NotFoundComponent extends Vue {
    constructor() {
        super();
    }
}
</script>
<style lang="less" >

.not-found-content {
    overflow: hidden;
    position: relative;
    width: 100%;
    img {
        width: 100%;
        height: auto;
    }
    .banner-text {
        right: 25%;
        top: 100px;
        left: 25%;
        display: block;
        background: rgba(255,255,255,0.9);
        padding: 2.4em 3.12em 1.6em;
        position: absolute;
        color:  #de3a6b;
    }

    .banner-text:before {
        content: '';
        display: block;
        height: 8px;
        position: relative;
        top: -2.4em;
        left: 0;
        right: 2em;
        z-index: 1;
        background-color: #de3a6b;
    }

    .banner-img {
        background-image: url('https://www.uniper.energy/sites/default/files/styles/hero_image/public/Uniper_Visual_Energy_quer.jpg?itok=CnGuF45k/');
        background-position: 20% 50%;
        background-repeat: no-repeat;
        background-size: cover;
        height: 100vh;
    }
  }
</style>
